import { Link, useParams } from "react-router";
import { conditionAnchor } from "../lib/links";
import type { CategoryEntry, TaxonomyEntry } from "../sources/taxonomy";

export function CategoryDetail({
  category,
  conditions,
}: {
  category: CategoryEntry;
  conditions: TaxonomyEntry[];
}) {
  const { tenant } = useParams();
  return (
    <div className="condition-detail">
      <p className="condition-full">{category.description}</p>
      {conditions.length > 0 && tenant ? (
        <div className="cat-conditions">
          <span className="meta-label">
            {conditions.length} condition{conditions.length === 1 ? "" : "s"} in this category
          </span>
          <ul className="cat-conditions-list">
            {conditions.map((c) => (
              <li key={c.code}>
                <Link
                  to={`/${tenant}/conditions#${conditionAnchor(c.code)}`}
                  onClick={(e) => e.stopPropagation()}
                  className="cat-cond-link"
                  title={`Open ${c.code} in Conditions tab`}
                >
                  <span className="mono cat-cond-code">{c.code}</span>
                  <span className="cat-cond-name">{c.name}</span>
                  <span className="mono cat-cond-short">{c.short_name}</span>
                  <span className="cat-cond-desc">{c.short_description}</span>
                </Link>
              </li>
            ))}
          </ul>
        </div>
      ) : null}
    </div>
  );
}
